const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/middleware/getCorrectEndpoint.ts';
import { getPatAppSettings } from 'App/utils/generalUtils';
import { isSecuredLocationPath } from 'App/utils/urlLocationCheck';
import { nativeAccessToken } from 'App/store/nativeAppAuth';

export function getCorrectEndpoint(store: any, deepRoute = 'patapi/ehr/kisapi') {
    const cfg = getPatAppSettings();
    const isReactNativeWebView = typeof (window as any).ReactNativeWebView !== 'undefined';

    let endPoint: string;

    if (isReactNativeWebView) {
        const isNativeApp = !!nativeAccessToken(store) && !!cfg.apiNativeSecuredHost;

        // NATIVE App over IDP
        endPoint = isNativeApp ? `${cfg.apiNativeSecuredHost}/${deepRoute}` : `${cfg.apiHost}/${deepRoute}`;
    } else if (isSecuredLocationPath()) {
        // WEB app over IDP
        endPoint = `${cfg.apiSecuredHost}/${deepRoute}`;
    } else {
        // generic by Aufgebotscode
        endPoint = `${cfg.apiHost}/${deepRoute}`;
    }

    // Manipulate endPoint
    const index = endPoint.indexOf('://');
    if (index !== -1) {
        endPoint = endPoint.substring(0, index + 3) + endPoint.substring(index + 3).replace('//', '/');
    } else {
        endPoint = endPoint.replace('//', '/');
    }

    return endPoint;
}
